import { AppRouter } from "../shared/components/AppRouter";
import { routes } from "./routes";

export const CollectiblesRoutes = () => <AppRouter routes={routes} />;
